import styled from 'styled-components';

export const StyledProgressBar = styled.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: transparent;
  border: 0;
  height: 24px;
  outline: 0;
  width: 100%;

  &:focus {
    outline: none;
  }

  &::-webkit-slider-runnable-track {
    background-image: linear-gradient(
      90deg,
      ${props => props.theme.genericColors.orangePeachy}
        ${props => props.percentage},
      ${props => props.theme.themeColors.footer.progressBar.trackColor}
        ${props => props.percentage}
    );
    cursor: pointer;
    height: 5px;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    background: ${props => props.theme.genericColors.orangePeachy};
    border-radius: 2px;
    border: none;
    cursor: pointer;
    height: 24px;
    margin-top: -10px;
    width: 10px;
  }
  &::-webkit-slider-thumb::before {
    content: "123";
    color: #000000;
  }
  &::-moz-range-progress {
    background-color: ${props => props.theme.genericColors.orangePeachy};
    border: 2px solid ${props => props.theme.genericColors.orangePeachy};
  }

  &::-moz-range-track {
    background: ${props =>
      props.theme.themeColors.footer.progressBar.trackColor};
    cursor: pointer;
    height: 5px;
    width: 100%;
  }

  &::-moz-range-thumb {
    background: ${props => props.theme.genericColors.orangePeachy};
    border-radius: 2px;
    border: none;
    cursor: pointer;
    height: 24px;
    width: 10px;
  }
`;
